/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from 'react';
import ApexCharts, { ApexOptions } from 'apexcharts';
import {
	getCSS,
	getCSSVariableValue,
} from '../../../../_metronic/assets/ts/_utils';
import { useThemeMode } from '../../../../_metronic/partials';
import { toAbsoluteUrl } from '../../../../_metronic/helpers';
import moment from 'moment';
import getSelectedDate from '../utils/getSelectedDate';
import { useSearchParams } from 'react-router-dom';
import request from '../../../../utils/request';
import { enAU } from 'date-fns/locale';
import { currencyFormat } from '../../../../utils';
moment.updateLocale(moment.locale('en', enAU), { invalidDate: '-' });

type Props = {
	className: string;
	statusColor?: string;
	setLastDate?: any;
	lastUnit: string;
};

const ChartDaily: React.FC<Props> = ({
	className,
	statusColor = '',
	setLastDate = {},
	lastUnit,
}) => {
	let custNum = localStorage.getItem('customerNum');
	const chartRef = useRef<HTMLDivElement | null>(null);
	const { mode } = useThemeMode();
	const [loading, setLoading] = useState(false);
	const [dataChart, setDataChart] = useState({
		data: [],
		categories: [],
		unit: '',
		latestUsage: 0,
	});
	const [dailyChartResponse, setDailyChartResponse] = useState<any>(null);

	useEffect(() => {
		setLoading(true);
		getDailyChartDashboard();
	}, []);

	useEffect(() => {
		const chart = refreshChart();

		return () => {
			if (chart) {
				chart.destroy();
			}
		};
	}, [/*chartRef, mode,, */ statusColor, dataChart]);


	const [searchParams] = useSearchParams();

	const _getSelectedDate = () => {
		return getSelectedDate(searchParams.get('date'));
	};

	const getDailyChartDashboard = async () => {
		const payload: any = {
			CustomerNumber: custNum,
			FromDate: _getSelectedDate().fromDate,
			ToDate: _getSelectedDate().toDate,
			// CustomerNumber: '034774895',
			// FromDate: '2023-12-01',
			// ToDate: '2023-12-12',
		};
		await request
			.post(`dashboard/GetDailyChartDashboard`, payload)
			.then((res) => {
				setLoading(false);
				if (res?.status === 200 || res?.status === 201) {
					const data = res.data;
					// const data: any = [
					// 	{
					// 		cust_number: '0150003331',
					// 		measure_day: '1',
					// 		energy: '250.1566',
					// 		volume: '6833.73',
					// 		uom: 'MMBTU Bulanan',
					// 	},
					// 	{
					// 		cust_number: '0150003331',
					// 		measure_day: '2',
					// 		energy: '252.0396',
					// 		volume: '6881.01',
					// 		uom: 'MMBTU Bulanan',
					// 	},
					// 	{
					// 		cust_number: '0150003331',
					// 		measure_day: '3',
					// 		energy: '261.1091',
					// 		volume: '7118.67',
					// 		uom: 'MMBTU Bulanan',
					// 	},
					// 	{
					// 		cust_number: '0150003331',
					// 		measure_day: '4',
					// 		energy: '264.0269',
					// 		volume: '7193.61',
					// 		uom: 'MMBTU Bulanan',
					// 	},
					// 	{
					// 		cust_number: '0150003331',
					// 		measure_day: '5',
					// 		energy: '262.6606',
					// 		volume: '7170.7',
					// 		uom: 'MMBTU Bulanan',
					// 	},
					// ];

					setDailyChartResponse(data.length === 0 ? null : data);

					if (data && data.length > 0) {
						const item = data[0];
						let isVol = false;
						if (
							item.uom &&
							(item.uom.includes('M3') ||
								item.uom === 'm³' ||
								item.uom.includes('<sup>'))
						) {
							isVol = true;
						}
						const unit = isVol ? 'm³' : 'MMBtu';
						const dataMap = data.map((item: any) => {
							return isVol ? item.volume : item.energy;
						});
						const catMap = data.map((item: any, index: number) => {
							return item.measure_day
								? parseInt(item.measure_day)
								: index;
						});
						const total = data.reduce((value, item) => {
							if (isVol) {
								value += parseFloat(item.volume || 0);
							} else {
								value += parseFloat(item.energy || 0);
							}
							return value;
						}, 0);
						const chartData = {
							data: dataMap,
							categories: catMap,
							unit,
							latestUsage: total, // / data.length,
							// xLabel: item?.uom.toLowerCase().includes('tahun') ? 'Yearly' : item?.uom.toLowerCase().includes('bulan') ? 'Monthly' : 'Daily'
							xLabel: 'Day'
						};
						setDataChart(chartData);
					}
				} else {
					console.log('DATA IS EMPTY');
				}
			});
	};

	const getLastDate = (dailyChart: any[]) => {
		let theLastDate = moment(_getSelectedDate().toDate).format(
			'DD MMM YYYY'
		);
		if (dailyChart && dailyChart.length > 0) {
			theLastDate =
				dailyChart[dailyChart.length - 1].measure_day +
				' ' +
				moment().format('MMM YYYY');
		}
		return theLastDate;
	};

	const refreshChart = () => {
		if (!chartRef.current) {
			return;
		}

		const height = parseInt(getCSS(chartRef.current, 'height'));

		const chart = new ApexCharts(
			chartRef.current,
			getChartOptions(height, statusColor, dataChart)
		);
		if (chart) {
			chart.render();
		}

		return chart;
	};

	const [isLargeScreen, setIsLargeScreen] = useState(
		window.matchMedia('(min-width: 992px)').matches
	);

	useEffect(() => {
		const handleResize = () => {
			setIsLargeScreen(window.matchMedia('(min-width: 992px)').matches);
		};

		window.addEventListener('resize', handleResize);

		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	useEffect(() => {
		setLastDate(getLastDate(dailyChartResponse));
	}, [dailyChartResponse]);

	return (
		<div className={`card ${className}`}>
			<div style={{ height: '140px' }} className="card-header border-2">
				<h3 className="card-title align-items-start flex-column">
					<span className="card-label fw-bold fs-3 mb-3">
						Daily chart
					</span>
					<span className="text-muted fw-bold fs-7">
						{moment(_getSelectedDate().fromDate).format(
							'DD MMM YYYY'
						)}{' '}
						{}-{' '}
						{moment(getLastDate(dailyChartResponse)).format(
							'DD MMM YYYY'
						)}
					</span>
					<div>
						<span className="text-dark fw-bold fs-7">
							{currencyFormat(dataChart.latestUsage)}{' '}
						</span>
						<span
							className="text-dark fw-bold fs-7"
							dangerouslySetInnerHTML={{
								__html:
									/*dataChart.unit || */ lastUnit || 'MMBtu',
							}}
						/>
					</div>
				</h3>
			</div>
			<div
				className="card-body"
				style={{
					overflowX: isLargeScreen ? 'auto' : 'scroll',
					overflowY: 'hidden',
				}}
			>
				{loading ? (
					<span
						className="indicator-progress w-100 text-center"
						style={{ display: 'block' }}
					>
						Please wait...{' '}
						<span className="spinner-border spinner-border-sm align-middle"></span>
					</span>
				) : (
					<>
						{(!dataChart ||
							!dataChart?.data ||
							dataChart?.data?.length === 0) && (
							<div className="d-flex justify-content-center mt-0 flex-wrap mb-8">
								<img
									className="w-50"
									style={{ objectFit: 'scale-down' }}
									src={toAbsoluteUrl(
										'/media/pgn/Empty state.png'
									)}
									alt=""
								/>
								{/* <div className="w-100 text-center fs-5 fw-semibold">
                        No data found.
                     </div> */}
							</div>
						)}
						<div
							hidden={
								!dataChart ||
								!dataChart?.data ||
								dataChart?.data?.length === 0
									? true
									: false
							}
							className={`${
								isLargeScreen ? '' : 'd-xs min-w-500px'
							}`}
							ref={chartRef}
							id="kt_charts_widget_1_chart"
							style={{ height: '350px' }}
						/>
					</>
				)}
			</div>
		</div>
	);

	// return (
	// 	<div className={`card ${className}`}>
	// 		<div style={{ height: '140px' }} className="card-header border-2">
	// 			<h3 className="card-title align-items-start flex-column">
	// 				<span className="card-label fw-bold fs-3 mb-3">
	// 					Daily chart
	// 				</span>
	// 				<span className="text-muted fw-bold fs-7">
	// 					{moment(_getSelectedDate().fromDate).format(
	// 						'DD MMM YYYY'
	// 					)}{' '}
	// 					-{' '}
	// 					{moment(_getSelectedDate().toDate).format(
	// 						'DD MMM YYYY'
	// 					)}
	// 				</span>
	// 				<div>
	// 					<span className="text-dark fw-bold fs-7">
	// 						{currencyFormat(dataChart.latestUsage)}{' '}
	// 					</span>
	// 					<span
	// 						className="text-dark fw-bold fs-7"
	// 						dangerouslySetInnerHTML={{
	// 							__html: dataChart.unit || 'MMBtu',
	// 						}}
	// 					/>
	// 				</div>
	// 			</h3>
	// 		</div>
	// 		<div
	// 			className="card-body"
	// 			style={{
	// 				overflowX: isLargeScreen ? 'auto' : 'scroll',
	// 				overflowY: 'hidden',
	// 			}}
	// 		>
	// 			{loading ? (
	// 				<span
	// 					className="indicator-progress w-100 text-center"
	// 					style={{ display: 'block' }}
	// 				>
	// 					Please wait...{' '}
	// 					<span className="spinner-border spinner-border-sm align-middle"></span>
	// 				</span>
	// 			) : (
	// 				<>
	// 					{(!dataChart ||
	// 						!dataChart?.data ||
	// 						dataChart?.data?.length === 0) && (
	// 						<div className="d-flex justify-content-center mt-0 flex-wrap mb-8">
	// 							<img
	// 								className="w-50"
	// 								style={{ objectFit: 'scale-down' }}
	// 								src={toAbsoluteUrl(
	// 									'/media/pgn/Empty state.png'
	// 								)}
	// 								alt=""
	// 							/>
	// 						</div>
	// 					)}
	// 					<div
	// 						hidden={
	// 							!dataChart ||
	// 							!dataChart?.data ||
	// 							dataChart?.data?.length === 0
	// 								? true
	// 								: false
	// 						}
	// 						// hidden={false}
	// 						className={`${
	// 							isLargeScreen ? '' : 'd-xs min-w-500px'
	// 						}`}
	// 						ref={chartRef}
	// 						id="kt_charts_widget_1_chart"
	// 						style={{ height: '350px' }}
	// 					></div>
	// 				</>
	// 			)}
	// 		</div>
	// 	</div>
	// );
};

export { ChartDaily };

function getChartOptions(
	height: number,
	statusColor: string,
	dataChart?: any
): ApexOptions {
	const labelColor = getCSSVariableValue('--bs-gray-500');
	const borderColor = getCSSVariableValue('--bs-gray-200');
	const baseColor = '#00548b';
	const secondaryColor = getCSSVariableValue('--bs-gray-300');
	let chartColor = baseColor;

	// if (statusColor == 'badge-light-warning') {
	// 	chartColor = '#00548b';
	// } else if (statusColor == 'badge-light-success') {
	// 	chartColor = '#b0ca29';
	// } else if (statusColor == 'badge-light-danger') {
	// 	chartColor = '#f1416c';
	// } else {
	// 	chartColor = '#6d6d80';
	// }

	return {
		series: [
			{
				name: 'Usage',
				data: dataChart.data,
			},
		],
		chart: {
			fontFamily: 'inherit',
			type: 'line',
			height: 350,
			toolbar: {
				show: false,
			},
		},
		plotOptions: {
			bar: {
				horizontal: false,
				columnWidth: '30%',
				borderRadius: 5,
			},
		},
		legend: {
			show: true,
		},
		dataLabels: {
			enabled: false,
		},
		fill: {
			type: 'solid',
			opacity: 1,
		},
		stroke: {
			curve: 'smooth',
			show: true,
			width: 3,
			colors: [chartColor, secondaryColor],
		},
		xaxis: {
			categories: dataChart.categories,
			title: {
				text: dataChart.xLabel,
				style: {
					fontWeight: '600',
				},
			},
			axisBorder: {
				show: true,
			},
			axisTicks: {
				show: false,
			},
			labels: {
				style: {
					colors: labelColor,
					fontSize: '12px',
				},
			},
			crosshairs: {
				position: 'front',
				stroke: {
					color: baseColor,
					width: 1,
					dashArray: 3,
				},
			},
			tooltip: {
				enabled: false
			}
		},
		yaxis: {
			axisBorder: {
				show: true,
			},
			title: {
				text:
					dataChart.unit &&
					(dataChart.unit.includes('<sup>') ||
						dataChart.unit === 'M3' ||
						dataChart.unit === 'm³')
						? 'm³'
						: 'MMBtu',
				style: { fontWeight: '600' },
			},
			labels: {
				style: {
					colors: labelColor,
					fontSize: '12px',
				},
				formatter: function (value: any) {
					return currencyFormat(value);
				},
			},
		},
		states: {
			normal: {
				filter: {
					type: 'none',
					value: 0,
				},
			},
			hover: {
				filter: {
					type: 'none',
					value: 0,
				},
			},
			active: {
				allowMultipleDataPointsSelection: false,
				filter: {
					type: 'none',
					value: 0,
				},
			},
		},
		tooltip: {
			style: {
				fontSize: '12px',
			},
			x: {
				formatter: function (val, { dataPointIndex }) {
					return dataChart.categories[dataPointIndex];
				},
			},
			y: {
				formatter: function (val) {
					return (
						currencyFormat(val) + ' ' + dataChart?.unit || 'MMBtu'
					);
				},
			},
		},
		colors: [chartColor, secondaryColor],
		grid: {
			borderColor: borderColor,
			strokeDashArray: 4,
			yaxis: {
				lines: {
					show: false,
				},
			},
			xaxis: {
				lines: {
					show: false,
				},
			},
		},
		markers: {
			size: 5,
			shape: 'circle',
		},
	};
}
